import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { PdfTemplate } from "components";
import { InventoryTurnoverResponse } from "../../types/InventoryTurnover";
import { getTurnoverStatus } from "../../utils/hooks/useInventoryTurnover";

export function ExportPdfInventoryTurnover({ dataList, turnoverRules }: {
  dataList: InventoryTurnoverResponse['data'],
  turnoverRules: InventoryTurnoverResponse['turnover_rule'],
}) {

    const columns = [
        { header: 'NO', key: 'no', width: 5 },
        { header: 'CODE', key: 'code', width: 20 },
        { header: 'PRODUCT NAME', key: 'product_name', width: 30 },
        { header: 'BEGIN QTY', key: 'begin_qty', width: 15 },
        { header: 'END QTY', key: 'end_qty', width: 15 },
        { header: 'AVG QTY', key: 'avg_qty', width: 15 },
        { header: 'UNIT SOLD', key: 'unit_sold', width: 15 },
        { header: 'TURNOVER (QTY)', key: 'qty_turnover', width: 15 },
        { header: 'DIO (Days)', key: 'dio', width: 10 },
        { header: 'STATUS', key: 'status', width: 20 },
    ];
    

    const dataMap: RowExportTypePdf[] = dataList.map((item, index: number) => {

        const rule = getTurnoverStatus(
            item.qty_turnover,
            turnoverRules
        );
        return {
            no: index + 1,
            code: item.product_barcode,
            product_name: item.product_name,
            begin_qty: {
                text: convertNumber(item.begin_qty ?? 0).intoCurrency,
                style: { textAlign: "right" }
            },
            end_qty: {
                text: convertNumber(item.end_qty ?? 0).intoCurrency,
                style: { textAlign: "right" }
            },
            avg_qty: {
                text: convertNumber(item.avg_qty ?? 0).intoCurrency,
                style: { textAlign: "right" }
            },
            unit_sold: {
                text: convertNumber(item.unit_sold ?? 0).intoCurrency,
                style: { textAlign: "right" }
            },
            qty_turnover: {
                text: convertNumber(item.qty_turnover ?? 0).intoCurrency,
                style: { textAlign: "right" }
            },
            dio: {
                text: item?.qty_turnover && item?.qty_turnover > 0 ? `${convertNumber(365/Number(item?.qty_turnover)).intoNormalAmount}` : "0",
                style: { textAlign: "right" }
            },
            status: rule?.mr_product_turnover_name ?? '-',
        }
    })

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORY"
            title="INVENTORY TURNOVER"
            column={columns}
        />
    )
}